/**
 * Facet Metadata Configuration
 * Maps Algolia facet attributes to widget types and translation keys
 * This is the only place where facet-specific configuration is needed
 */

(function facetMetadataInit(globalWindow) {
  // Facet metadata configuration
  // Maps facet attribute names to their widget type and translation keys
  const FACET_METADATA = {
    // Core facets
    price: {
      type: "range",
      translationKey: "price",
    },
    collections: {
      type: "refinement",
      translationKey: "collections",
      searchable: true,
    },
    vendor: {
      type: "refinement",
      translationKey: "manufacturer",
    },
    product_type: {
      type: "refinement",
      translationKey: "productType",
    },

    // Special facets
    "meta.custom.express_tag": {
      type: "express",
      translationKey: "expressShipping",
    },
    "meta.custom.item_categories": {
      type: "hierarchical",
      translationKey: "kategorien",
      limit: 1000,
      showMore: true,
      showMoreLimit: 2000,
    },

    // Weitere Informationen attributes - Electrical
    "meta.custom.weitere_informationen.Anschluss in Volt": {
      type: "refinement",
      translationKey: "anschlussInVolt",
    },

    // Weitere Informationen attributes - Kitchen Equipment
    "meta.custom.weitere_informationen.Anzahl Kochstellen": {
      type: "grouped_numeric",
      translationKey: "anzahlKochstellen",
    },
    "meta.custom.weitere_informationen.Anzahl Türen": {
      type: "refinement",
      translationKey: "anzahlTueren",
    },
    "meta.custom.weitere_informationen.Aufkantung": {
      type: "refinement",
      translationKey: "aufkantung",
    },

    // Weitere Informationen attributes - Dimensions
    "meta.custom.weitere_informationen.Breite in mm": {
      type: "grouped_numeric",
      translationKey: "breiteInMm",
    },
    "meta.custom.weitere_informationen.Höhe in mm": {
      type: "grouped_numeric",
      translationKey: "hoeheInMm",
    },
    "meta.custom.weitere_informationen.Tiefe in mm": {
      type: "grouped_numeric",
      translationKey: "tiefeInMm",
    },

    // Weitere Informationen attributes - Equipment Specifications
    "meta.custom.weitere_informationen.Durchmesser des Schneidmessers": {
      type: "refinement",
      translationKey: "durchmesserDesSchneidmessers",
    },
    "meta.custom.weitere_informationen.Enthärter": {
      type: "refinement",
      translationKey: "enthaerter",
    },
    "meta.custom.weitere_informationen.GN Maß": {
      type: "refinement",
      translationKey: "gnMass",
    },
    "meta.custom.weitere_informationen.Gerätetyp": {
      type: "refinement",
      translationKey: "geraetetyp",
    },
    "meta.custom.weitere_informationen.Grundboden": {
      type: "refinement",
      translationKey: "grundboden",
    },

    // Weitere Informationen attributes - Cooking
    "meta.custom.weitere_informationen.Kochart": {
      type: "refinement",
      translationKey: "kochart",
    },
    "meta.custom.weitere_informationen.Korbmaße in mm": {
      type: "refinement",
      translationKey: "korbmasseInMm",
    },

    // Weitere Informationen attributes - Cooling
    "meta.custom.weitere_informationen.Kühlbereich": {
      type: "refinement",
      translationKey: "kuehlbereich",
    },
    "meta.custom.weitere_informationen.Kühlung": {
      type: "refinement",
      translationKey: "kuehlung",
    },
    "meta.custom.weitere_informationen.Kühlvolumen [Liter]": {
      type: "grouped_numeric",
      translationKey: "kuehlvolumenLiter",
    },

    // Weitere Informationen attributes - Washing/Cleaning
    "meta.custom.weitere_informationen.Laugenpumpe": {
      type: "refinement",
      translationKey: "laugenpumpe",
    },
    "meta.custom.weitere_informationen.Spülbeckenanzahl": {
      type: "refinement",
      translationKey: "spuelbeckenanzahl",
    },
    "meta.custom.weitere_informationen.spuelmaschinenart": {
      type: "refinement",
      translationKey: "spuelmaschinenart",
    },

    // Weitere Informationen attributes - Materials & Construction
    "meta.custom.weitere_informationen.Material": {
      type: "refinement",
      translationKey: "material",
    },
    "meta.custom.weitere_informationen.Montageform": {
      type: "refinement",
      translationKey: "montageform",
    },
    "meta.custom.weitere_informationen.Türart": {
      type: "refinement",
      translationKey: "tuerart",
    },

    // Weitere Informationen attributes - Furniture
    "meta.custom.weitere_informationen.chair_type": {
      type: "refinement",
      translationKey: "chairType",
    },
    "meta.custom.weitere_informationen.klappbar": {
      type: "refinement",
      translationKey: "klappbar",
    },
    "meta.custom.weitere_informationen.stapelfähig": {
      type: "refinement",
      translationKey: "stapelfaehig",
    },
    "meta.custom.weitere_informationen.tischform": {
      type: "refinement",
      translationKey: "tischform",
    },

    // Weitere Informationen attributes - Product Lines
    "meta.custom.weitere_informationen.Serie": {
      type: "refinement",
      translationKey: "serie",
    },
    "meta.custom.weitere_informationen.Qualitätsstufe": {
      type: "refinement",
      translationKey: "qualitaetsstufe",
    },
    
    // French equivalents (Weitere Informationen attributes - French metafield keys)
    // Electrical
    'meta.custom.weitere_informationen.Raccordement en volt': {
      type: 'refinement',
      translationKey: 'anschlussInVolt',
    },

    // Kitchen Equipment
    'meta.custom.weitere_informationen.Nombre de feux': {
      type: 'grouped_numeric',
      translationKey: 'anzahlKochstellen',
    },
    'meta.custom.weitere_informationen.Nombre de portes': {
      type: 'refinement',
      translationKey: 'anzahlTueren',
    },
    'meta.custom.weitere_informationen.Rebord': {
      type: 'refinement',
      translationKey: 'aufkantung',
    },

    // Dimensions
    'meta.custom.weitere_informationen.Largeur en mm': {
      type: 'grouped_numeric',
      translationKey: 'breiteInMm',
    },
    'meta.custom.weitere_informationen.Hauteur en mm': {
      type: 'grouped_numeric',
      translationKey: 'hoeheInMm',
    },
    'meta.custom.weitere_informationen.Profondeur en mm': {
      type: 'grouped_numeric',
      translationKey: 'tiefeInMm',
    },

    // Equipment Specifications
    'meta.custom.weitere_informationen.Diamètre de la lame de coupe': {
      type: 'refinement',
      translationKey: 'durchmesserDesSchneidmessers',
    },
    'meta.custom.weitere_informationen.Adoucisseur': {
      type: 'refinement',
      translationKey: 'enthaerter',
    },
    'meta.custom.weitere_informationen.Dimension GN': {
      type: 'refinement',
      translationKey: 'gnMass',
    },
    "meta.custom.weitere_informationen.Type d'appareil": {
      type: 'refinement',
      translationKey: 'geraetetyp',
    },
    'meta.custom.weitere_informationen.Fond': {
      type: 'refinement',
      translationKey: 'grundboden',
    },

    // Cooking
    'meta.custom.weitere_informationen.Mode de cuisson': {
      type: 'refinement',
      translationKey: 'kochart',
    },
    'meta.custom.weitere_informationen.Dimensions du panier en mm': {
      type: 'refinement',
      translationKey: 'korbmasseInMm',
    },

    // Cooling
    'meta.custom.weitere_informationen.Plage de réfrigération': {
      type: 'refinement',
      translationKey: 'kuehlbereich',
    },
    'meta.custom.weitere_informationen.Réfrigération': {
      type: 'refinement',
      translationKey: 'kuehlung',
    },
    'meta.custom.weitere_informationen.Volume de réfrigération [Litres]': {
      type: 'grouped_numeric',
      translationKey: 'kuehlvolumenLiter',
    },

    // Washing/Cleaning
    'meta.custom.weitere_informationen.Pompe de vidange': {
      type: 'refinement',
      translationKey: 'laugenpumpe',
    },
    'meta.custom.weitere_informationen.Nombre de bacs de lavage': {
      type: 'refinement',
      translationKey: 'spuelbeckenanzahl',
    },

    // Materials & Construction
    'meta.custom.weitere_informationen.Matériau': {
      type: 'refinement',
      translationKey: 'material',
    },
    'meta.custom.weitere_informationen.Forme de montage': {
      type: 'refinement',
      translationKey: 'montageform',
    },
    'meta.custom.weitere_informationen.Type de porte': {
      type: 'refinement',
      translationKey: 'tuerart',
    },

    // Furniture
    'meta.custom.weitere_informationen.Pliable': {
      type: 'refinement',
      translationKey: 'klappbar',
    },
    'meta.custom.weitere_informationen.Empilable': {
      type: 'refinement',
      translationKey: 'stapelfaehig',
    },

    // Product Lines
    'meta.custom.weitere_informationen.Série': {
      type: 'refinement',
      translationKey: 'serie',
    },
    'meta.custom.weitere_informationen.Niveau de qualité': {
      type: 'refinement',
      translationKey: 'qualitaetsstufe',
    },
    
  };

  // Helper function to get metadata for a facet
  const getFacetMetadata = function getFacetMetadata(facetName) {
    return (
      FACET_METADATA[facetName] || {
        type: "refinement",
        translationKey: facetName.split(".").pop().replace(/[-_]/g, ""),
      }
    );
  };

  // Helper function to get translation for a facet
  const getFacetTranslation = function getFacetTranslation(translationKey) {
    // Try different translation sources in order of priority
    // 1. First check the new facetTranslations object
    if (globalWindow.facetTranslations?.[translationKey]) {
      return globalWindow.facetTranslations[translationKey];
    }

    // 4. Final fallback: Convert camelCase to readable format
    return translationKey
      .replace(/([A-Z])/g, " $1")
      .replace(/^./, (str) => str.toUpperCase())
      .trim();
  };

  // Export to global window object
  if (typeof globalWindow !== "undefined") {
    const FacetMetadata = {
      FACET_METADATA,
      getFacetMetadata,
      getFacetTranslation,
    };
    Object.assign(globalWindow, { FacetMetadata });
  }
})(window);
